import './project.css';
import useScrollReveal from '../../hooks/useScrollReveal';

const projects = [
  {
    title: '3EduPlus',
    description:
      'A comprehensive e-learning platform that enables students to access courses, track progress, and interact with instructors in a modern, user-friendly interface.',
    tags: ['HTML', 'CSS', 'Php','Xampp'],
    link: '#',
  },
  {
    title: 'A+Market',
    description:
      'A modern, scalable e-commerce platform with cart management, product search and filtering, user authentication, and seamless checkout flow.',
    tags: ['React.js', 'Next.js', 'Mysql'],
    link: '#',
  },
  {
    title: 'Portfolio Website',
    description:
      'A personal portfolio showcasing my projects, skills, and experience. Built with React, featuring scroll animations, responsive design, and a contact form.',
    tags: ['React', 'CSS3', 'Formspree'],
    link: '#',
  }
];

function Project() {
  const sectionRef = useScrollReveal();

  return (
    <div className="Project-page" id="Projects" ref={sectionRef}>
      <h1 className="scroll-reveal">
        Projects <span className="highlight-gradient">Made</span>
      </h1>
      <p className="project-subtitle scroll-reveal delay-1">
        A selection of projects I've built and contributed to
      </p>

      <div className="Project-Container">
        {projects.map((project, index) => (
          <div
            className={`Project-Item scroll-reveal delay-${(index % 4) + 1}`}
            key={project.title}
          >
            <div className="Project-Card">
              <div className="Project-Card-Inner">
                <div className="project-number">
                  {String(index + 1).padStart(2, '0')}
                </div>
                <h2>{project.title}</h2>
                <p>{project.description}</p>
                <div className="project-tags">
                  {project.tags.map((tag) => (
                    <span className="tag" key={tag}>
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
              <div className="project-card-glow"></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Project;
